import { useEffect, useState } from 'react';
import * as Lucide from 'lucide-react';
import { Reveal } from '@/components/ui/Reveal';
import CPAMBadge from '@/components/ui/CPAMBadge';
import { useSEO } from '@/lib/seo';
import api from '@/lib/api';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function Services() {
  useSEO({
    title: "Nos services | Groupe Ambulances Beaulon",
    description: "Ambulance, VSL, taxi conventionné, longue distance, transport hospitalier, dialyse, rééducation, transport PMR : tous nos services dans l'Allier.",
    keywords: "services ambulance allier, vsl allier, taxi conventionné allier, dialyse, rééducation, transport PMR"
  });

  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get('/services', { params: { category: 'standard' } }).then(r => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <section className="hero-wash">
        <div className="container-app pt-14 pb-10">
          <Reveal>
            <div className="flex items-center gap-2 mb-3 flex-wrap">
              <p className="badge-soft">Nos services</p>
              <CPAMBadge variant="solid" size="sm" />
            </div>
            <h1 className="h1 text-anthracite-950">Une réponse adaptée à chaque trajet</h1>
            <p className="lead mt-4 max-w-3xl">Du transport quotidien au trajet longue distance, nos équipes prennent en charge l'ensemble de vos besoins de transport sanitaire. <span className="font-medium text-anthracite-900">Tous nos services sont conventionnés CPAM.</span></p>
          </Reveal>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-app">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((s, i) => {
              const Icon = Lucide[s.icon] || Lucide.Ambulance;
              return (
                <Reveal key={s.id} delay={i * 40}>
                  <article className="card-base p-6 h-full flex flex-col gap-3" data-testid={`service-card-${s.title.toLowerCase().replace(/\s/g, '-')}`}>
                    <div className="h-11 w-11 rounded-xl bg-brand-50 text-brand-700 flex items-center justify-center">
                      <Icon className="h-5 w-5" />
                    </div>
                    <h3 className="h3 text-anthracite-950">{s.title}</h3>
                    <p className="text-sm text-anthracite-700 leading-relaxed">{s.description}</p>
                  </article>
                </Reveal>
              );
            })}
          </div>

          <div className="mt-12 rounded-2xl border bg-anthracite-100/60 p-6 sm:p-8 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
            <div>
              <h3 className="h3 text-anthracite-950">Une question spécifique ?</h3>
              <p className="text-sm text-anthracite-700 mt-1">Notre équipe vous accompagne dans le choix du transport le plus adapté.</p>
            </div>
            <div className="flex gap-3 flex-wrap">
              <Link to="/devis"><Button>Demande de devis</Button></Link>
              <Link to="/transports-specialises"><Button variant="outline">Transports spécialisés</Button></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
